// 화면 위치 헤더(X-Client-App·X-Audit-Screen) — 계약 AUDIT 2절 screen·source.app. 표시용이라 판정에 쓰지 않음.
// admin-hospital·admin-manufacturer 같은 내용 — 앱마다 다른 것은 CLIENT_APP 한 줄.
// Vue·axios 를 들이지 않는 순수 모듈(tests/clientHeaders.test.mjs).
export const CLIENT_APP = "admin-manufacturer";
const SCREEN_RE = /^[A-Za-z0-9_.:/#-]{1,64}$/; // 서버 cleanScreen() 과 같은 식
let currentScreen;

const fit = (v) => (typeof v === "string" && SCREEN_RE.test(v) ? v : undefined);

/** 라우트 → 화면 위치 값: name(형식이 맞을 때) → 경로 틀(/customer/:id) → 없음(헤더를 뺌) */
export const screenOf = (route) => {
  if (!route) return undefined;
  const matched = route.matched || [];
  return (
    fit(route.name) ||
    fit(matched.length ? matched[matched.length - 1].path : undefined)
  );
};

/** router.afterEach 에서 부름 */
export const setAuditScreen = (route) => {
  currentScreen = screenOf(route);
};

/** 요청 가로채기에서 부름. 형식에 안 맞으면 X-Audit-Screen 은 빼고 보냄(서버도 버림) */
export const withClientHeaders = (config) => {
  config.headers = config.headers || {};
  config.headers["X-Client-App"] = CLIENT_APP;
  if (currentScreen) config.headers["X-Audit-Screen"] = currentScreen;
  else delete config.headers["X-Audit-Screen"];
  return config;
};
